import * as React from "react";
const DesktopPreview = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={336}
    height={250}
    viewBox="0 0 336 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_138_2374)">
      <path
        d="M11.2394 0H325.648C331.361 0 336 4.68643 336 10.4573V185.543C336 191.314 331.361 196 325.648 196H10.9437C4.90356 196 0 191.047 0 184.945V11.3537C0 5.08757 5.03639 0 11.2394 0Z"
        fill="#7C95A5"
      />
      <path
        d="M0.295775 0H336V196H0V0.298781C0 0.134175 0.132825 0 0.295775 0Z"
        fill="#1578F7"
      />
      <path d="M336 32H0V250H336V32Z" fill="white" />
      <path
        d="M90.6522 20.3171C88.6078 20.3171 86.9495 18.642 86.9523 16.5754C86.9564 13.192 86.9577 8.73932 86.9577 8.73932C86.9577 5.56339 84.4081 2.98779 81.2641 2.98779H28.7641C25.6201 2.98779 23.0704 5.56339 23.0704 8.73932C23.0704 8.73932 23.0718 12.344 23.0745 15.531C23.0773 18.1744 20.9562 20.3171 18.3408 20.3171H0V42.4268H336V20.3171H90.6522Z"
        fill="white"
      />
      <path
        d="M14.5914 31.3223C14.5859 31.5865 14.3695 31.7981 14.108 31.7926L4.40904 31.6086C4.14749 31.6031 3.93799 31.3845 3.94346 31.1203C3.94894 30.8561 4.1653 30.6445 4.42684 30.65L14.1258 30.834C14.3873 30.8395 14.5968 31.0581 14.5914 31.3223Z"
        fill="#D7D9E5"
      />
      <path
        d="M4.01794 31.0106L4.12604 30.8893C4.2378 30.7639 4.42834 30.7547 4.55149 30.8667L8.07297 34.0686C8.19713 34.1815 8.20618 34.3739 8.09534 34.4983L7.98724 34.6197C7.87548 34.7451 7.68494 34.7542 7.56179 34.6423L4.04031 31.4404C3.91615 31.3275 3.9071 31.135 4.01794 31.0106Z"
        fill="#D7D9E5"
      />
      <path
        d="M8.22223 27.9032L8.11874 27.7779C8.01217 27.6488 7.8222 27.6315 7.69443 27.7391L4.05599 30.8046C3.92823 30.9123 3.91104 31.1042 4.0176 31.2332L4.1211 31.3586C4.22766 31.4876 4.41763 31.505 4.5454 31.3973L8.18384 28.3318C8.31161 28.2242 8.3288 28.0323 8.22223 27.9032Z"
        fill="#D7D9E5"
      />
      <path
        d="M19.9161 31.3223C19.9216 31.5865 20.138 31.7981 20.3995 31.7926L30.0984 31.6086C30.36 31.6031 30.5695 31.3845 30.564 31.1203C30.5585 30.8561 30.3422 30.6445 30.0806 30.65L20.3817 30.834C20.1201 30.8395 19.9106 31.0581 19.9161 31.3223Z"
        fill="#D7D9E5"
      />
      <path
        d="M26.5192 34.6173L26.4111 34.4959C26.2994 34.3705 26.3104 34.1781 26.4336 34.0662L29.9556 30.865C30.0798 30.7521 30.2702 30.7632 30.381 30.8876L30.4891 31.009C30.6009 31.1344 30.5898 31.3268 30.4667 31.4387L26.9446 34.64C26.8205 34.7528 26.63 34.7417 26.5192 34.6173Z"
        fill="#D7D9E5"
      />
      <path
        d="M30.391 31.3593L30.4945 31.2339C30.6011 31.1049 30.5839 30.913 30.4562 30.8053L26.8177 27.7398C26.6899 27.6322 26.5 27.6495 26.3934 27.7786L26.2899 27.904C26.1834 28.033 26.2005 28.2249 26.3283 28.3326L29.9667 31.3981C30.0945 31.5057 30.2845 31.4884 30.391 31.3593Z"
        fill="#D7D9E5"
      />
      <path
        d="M310.627 23.1265H48.8941C44.4836 23.1265 40.9082 26.7382 40.9082 31.1935C40.9082 35.6489 44.4836 39.2606 48.8941 39.2606H310.627C315.038 39.2606 318.613 35.6489 318.613 31.1935C318.613 26.7382 315.038 23.1265 310.627 23.1265Z"
        fill="#EFF2FF"
      />
      <path
        d="M327.866 29.3746H324.661C324.033 29.3746 323.523 28.8601 323.523 28.2252C323.523 27.5902 324.033 27.0757 324.661 27.0757H327.866C328.494 27.0757 329.003 27.5902 329.003 28.2252C329.003 28.8601 328.494 29.3746 327.866 29.3746Z"
        fill="#CFD3E8"
      />
      <path
        d="M327.866 32.3431H324.661C324.033 32.3431 323.523 31.8286 323.523 31.1937C323.523 30.5588 324.033 30.0442 324.661 30.0442H327.866C328.494 30.0442 329.003 30.5588 329.003 31.1937C329.003 31.8286 328.494 32.3431 327.866 32.3431Z"
        fill="#CFD3E8"
      />
      <path
        d="M327.866 35.3102H324.661C324.033 35.3102 323.523 34.7956 323.523 34.1607C323.523 33.5258 324.033 33.0112 324.661 33.0112H327.866C328.494 33.0112 329.003 33.5258 329.003 34.1607C329.003 34.7956 328.494 35.3102 327.866 35.3102Z"
        fill="#CFD3E8"
      />
      <path
        d="M52.0413 27.5279C50.8431 26.3175 48.8918 26.3175 47.6937 27.5279C46.4955 28.7382 46.4955 30.7093 47.6937 31.9197C48.7535 32.9903 50.3995 33.1134 51.5962 32.2918L54.8676 35.5963C55.0921 35.8232 55.4564 35.8232 55.681 35.5963C55.9055 35.3695 55.9055 35.0015 55.681 34.7747L52.4096 31.4701C53.223 30.2625 53.1011 28.5985 52.0413 27.5279ZM51.2279 31.0994C50.4775 31.8574 49.2574 31.8574 48.507 31.0994C47.7567 30.3414 47.7567 29.1089 48.507 28.3509C49.2574 27.5929 50.4775 27.5929 51.2279 28.3509C51.9783 29.1089 51.9783 30.3414 51.2279 31.0994Z"
        fill="#CFD3E8"
      />
      <path
        opacity={0.2}
        d="M301.575 69H190.425C189.638 69 189 70.1968 189 71.6731V175.327C189 176.803 189.638 178 190.425 178H301.575C302.362 178 303 176.803 303 175.327V71.6731C303 70.1968 302.362 69 301.575 69Z"
        fill="#F2F3F8"
      />
      <g clipPath="url(#clip1_138_2374)">
        <rect
          width={113.679}
          height={108.944}
          transform="translate(189 69)"
          fill="#F2F3F8"
        />
        <path
          opacity={0.2}
          d="M290.767 124.359C319.845 124.359 334.011 147.238 362.344 177.944C339.231 177.944 240.279 177.944 211.732 177.944C236.337 152.656 261.688 124.359 290.767 124.359Z"
          fill="#D3DAFB"
        />
        <path
          opacity={0.2}
          d="M193.979 115.834C225.06 115.834 245.17 145.45 272.958 177.944C236.497 177.944 148.2 177.944 115 177.944C141.842 145.45 162.899 115.834 193.979 115.834Z"
          fill="#CDD9FF"
        />
        <path
          opacity={0.5}
          d="M246.016 116.041C252.103 116.041 257.037 111.107 257.037 105.02C257.037 98.9341 252.103 94 246.016 94C239.93 94 234.996 98.9341 234.996 105.02C234.996 111.107 239.93 116.041 246.016 116.041Z"
          fill="#D3DAFB"
        />
      </g>
      <path
        opacity={0.2}
        d="M303.669 198H27V204.5H303.669V198Z"
        fill="#CED1DE"
      />
      <path
        opacity={0.2}
        d="M303.669 213.167H27V219.667H303.669V213.167Z"
        fill="#CED1DE"
      />
      <path
        opacity={0.2}
        d="M303.669 228.333H27V234.833H303.669V228.333Z"
        fill="#CED1DE"
      />
      <path
        opacity={0.5}
        d="M167.781 112H30.2188C28.9933 112 28 112.895 28 114C28 115.105 28.9933 116 30.2188 116H167.781C169.007 116 170 115.105 170 114C170 112.895 169.007 112 167.781 112Z"
        fill="#E3E8FF"
      />
      <path
        d="M65.7778 143H30.2222C28.9949 143 28 143.97 28 145.167V153.833C28 155.03 28.9949 156 30.2222 156H65.7778C67.0051 156 68 155.03 68 153.833V145.167C68 143.97 67.0051 143 65.7778 143Z"
        fill="#E3E8FF"
      />
      <path
        d="M100.794 94H30.2059C28.9876 94 28 95.0073 28 96.25V100.75C28 101.993 28.9876 103 30.2059 103H100.794C102.012 103 103 101.993 103 100.75V96.25C103 95.0073 102.012 94 100.794 94Z"
        fill="#E3E8FF"
      />
      <circle cx={320.5} cy={11.5} r={3.5} fill="white" />
      <circle cx={309.5} cy={11.5} r={3.5} fill="white" />
      <circle cx={298.5} cy={11.5} r={3.5} fill="white" />
      <line y1={41.5} x2={336} y2={41.5} stroke="#F2F3F8" />
      <rect x={30} y={10} width={40} height={3} fill="#EBEEF9" />
      <path
        d="M44 197.103C54.4368 197.103 62.8975 205.563 62.8975 216C62.8974 226.437 54.4367 234.897 44 234.897C33.5632 234.897 25.1026 226.437 25.1025 216C25.1025 205.563 33.5632 197.103 44 197.103Z"
        stroke="white"
        strokeWidth={2}
      />
      <path
        d="M42.4978 210.399C44.2129 210.399 45.6039 208.988 45.6039 207.248V207.151C45.6039 205.411 44.2129 204 42.4978 204C40.7827 204 39.3917 205.411 39.3917 207.151V207.248C39.3917 208.988 40.7827 210.399 42.4978 210.399Z"
        fill="white"
      />
      <path
        d="M33 225.16L36.1096 227.998L42.3513 220.963L39.2679 218.095L33 225.16Z"
        fill="white"
      />
      <path
        d="M54 209.727L51.0909 206.677L42.8185 214.798L38.5411 210.659L35.6686 213.712L42.9283 220.595L42.9545 220.571L42.958 220.576L45.2709 218.24L43.4059 221.076L49.0672 227.945L52.2692 225.214L45.9681 217.613L54 209.727Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_138_2374">
        <rect width={336} height={250} rx={6} fill="white" />
      </clipPath>
      <clipPath id="clip1_138_2374">
        <rect
          width={113.679}
          height={108.944}
          fill="white"
          transform="translate(189 69)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default DesktopPreview;
